import { motion, useViewportScroll, useTransform } from "framer-motion";
import { ParallaxProvider, Parallax } from "react-scroll-parallax";
import DiamondClicker from "../components/DiamondClicker";
import { useInView } from "react-intersection-observer";
import { Canvas } from '@react-three/fiber'

import ScaleServer from "../components/ScaleServer";
import DepthImage from "../components/DepthImage";

//images
import Apple from "../images/mainServer/Apple.png";
import Castle from "../images/mainServer/Castle.png";
import GuardianIsland from "../images/mainServer/GuardianIsland.png";
import Mansion from "../images/mainServer/Mansion.png";

import Golf from "../images/mainServer/Golf.png";
import Ship from "../images/mainServer/Ship.png";

import GuardianIslandDepth from "../images/mainServer/GuardianIslandDepth.png";

export default function Home() {
  const { scrollYProgress } = useViewportScroll();

  const fadeVariants = {
    hidden: { opacity: 0, y: 100 },
    visible: { opacity: 1, y: 0 },
  };

  const [mainRef, mainInView] = useInView({ threshold: 0.3 });
  const [prisonRef, prisonInView] = useInView({ threshold: 0.3 });
  const [oliviaRef, oliviaInView] = useInView({ threshold: 0.3 });
  const [monarchyRef, monarchyInView] = useInView({ threshold: 0.3 });

  return (
    <ParallaxProvider>
      <div className="pt-20">
        {/*main server*/}
        <motion.section
          ref={mainRef}
          variants={fadeVariants}
          initial="hidden"
          animate={mainInView ? "visible" : "hidden"}
          transition={{ duration: 0.8 }}
          className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-dark to-pinky/10 px-6 text-center"
        >
          <h2 className="text-5xl text-pinky font-bold mb-6">VivtorCraft Server</h2>
          <p className="text-gray-300 max-w-2xl mb-12">
            The place where players create cities, stories, and endless amount of LORE!
          </p>
          <section className="w-screen relative h-screen">
            <Canvas camera={{ position: [0, 0, 3] }}>
              <ambientLight intensity={2.5} />
              <directionalLight position={[0, 2, 5]} intensity={1} />
              <DepthImage image={GuardianIsland} depth={GuardianIslandDepth} />
            </Canvas>
          </section>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 w-full max-w-5xl">
            <motion.img src={Apple} className="rounded-xl" whileHover={{ scale: 1.05 }} />
            <motion.img src={Castle} className="rounded-xl" whileHover={{ scale: 1.05 }} />
            <motion.img src={Golf} className="rounded-xl" whileHover={{ scale: 1.05 }} />
            <motion.img src={Mansion} className="rounded-xl" whileHover={{ scale: 1.05 }} />
            <motion.img src={Ship} className="rounded-xl" whileHover={{ scale: 1.05 }} />
          </div>
        </motion.section>

        {/*transition*/}
        <motion.div
          className="h-40 bg-gradient-to-b from-pinky/10 to-gray-900"
          initial={{ opacity: 0 }}
          animate={{ opacity: mainInView ? 1 : 0 }}
          transition={{ duration: 1 }}
        />

        {/*prison server*/}
        <motion.section
          ref={prisonRef}
          variants={fadeVariants}
          initial="hidden"
          animate={prisonInView ? "visible" : "hidden"}
          transition={{ duration: 0.8 }}
          className="min-h-screen flex flex-col md:flex-row items-center justify-center gap-12 bg-gray-900 px-8 text-center"
        >
          <DiamondClicker />
          <div>
            <h3 className="text-4xl text-pinky font-bold mb-3">💎 The Prison Server</h3>
            <p className="text-gray-300 max-w-md">
              Mine your way to freedom in this blocky prison full of blocks or hope your back in the story!
            </p>
          </div>
        </motion.section>

        {/*scale server*/}
        <ScaleServer />

        {/*cozy server*/}
        <motion.section
          ref={oliviaRef}
          variants={fadeVariants}
          initial="hidden"
          animate={oliviaInView ? "visible" : "hidden"}
          transition={{ duration: 0.8 }}
          className="min-h-screen bg-gradient-to-b from-pinky/20 to-pinky/5 flex flex-col items-center justify-center text-center"
        >
          <h3 className="text-4xl text-pinky font-bold mb-2">☕ Olivia’s Cozy Server</h3>
          <p className="text-white max-w-md">
            A calm server that not that many players play on.
          </p>
        </motion.section>

        {/*monarchy*/}
        <motion.section
          ref={monarchyRef}
          variants={fadeVariants}
          initial="hidden"
          animate={monarchyInView ? "visible" : "hidden"}
          transition={{ duration: 0.8 }}
          className="min-h-screen bg-black flex flex-col items-center justify-center text-center text-gray-400"
        >
          <h3 className="text-4xl text-red-400 font-bold mb-2">⚔️ The Monarchy</h3>
          <p className="max-w-md italic">
            A dangerous server that is spoken upon. No one truely knows how to go here...
          </p>
        </motion.section>
      </div>
    </ParallaxProvider>
  );
}